import React from "react";
import styled from "styled-components";
import { UI_TAG } from "oolib/dist/v2/components/Typo2";

const PillRoot = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: ${(p) => (p.$hasIcon ? "2.5px 8px 2.5px 4px" : "4px 8px")};
  border-radius: 999px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$color};
  flex-shrink: 0;
`;

export function StatusPill({ theme, label, iconSize = 16, as }) {
  if (!theme) return null;
  const Icon = theme.Icon;
  return (
    <PillRoot $bg={theme.bg} $color={theme.color} $hasIcon={!!Icon} as={as}>
      {Icon && <Icon size={iconSize} weight="bold" color={theme.color} />}
      <UI_TAG>{label || theme.label}</UI_TAG>
    </PillRoot>
  );
}
